export default __webpack_public_path__ + "static/media/configuration.b1939ded.svg";